export const formatAircraftLabel = ({
    nickname,
    model,
    id,
}: {
    nickname: string | null
    model: string | null
    id: string
}) => (nickname ? `${nickname} (${model})` : (model ?? id))
